import React, { Suspense, lazy, useEffect, useState } from "react";
import { Badge } from "react-bootstrap";
import styled from "styled-components";
import ParametrageModal from "../../Components/AppParametrages/Parametrages/ParametrageModal";
import {
  ActiveMenu,
  findParametragesMenusApi,
  updatePositionMenusApi,
} from "../../_App/Redux/Slices/AppParametrages/parametrageMenus/parametrageMenuSlice";
import { useAppDispatch, useAppSelector } from "../../_App/Redux/hooks";
import AppMenuItemsType from "../../_App/Types/Entites/AppMenus/AppMenuItems";
import AppMenuParametrageType from "../../_App/Types/Entites/AppMenus/AppMenuParametrageType";
import _ from "lodash";
import {
  logoutApi,
  selectedAutorisations,
} from "../../_App/Redux/Slices/Auth/authSlice";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
const MenuStyled = styled.div<{
  $compactmode: boolean;
  $menu: AppMenuParametrageType | null;
}>`
  height: 130px;

  div.sidebar-wrapper {
    width: 100%;
    height: ${(props) => (props.$compactmode ? "130px" : "550px")};
    bottom: 0px;
    top: 0px;
    border-top-right-radius: 0px;
    background: ${({ $menu }) =>
      $menu ? $menu?.menuPosition?.bgColor : "#e0f0ef"};
  }
  div.sidebar-wrapper > nav#compactSidebar {
    position: relative;
    width: 100%;
    height: ${(props) => (props.$compactmode ? "130px" : "550px")};
    bottom: 0px;
    top: auto;
    border-top-right-radius: 0px;
    display: flex;
    justify-content: center;
    flex: auto;
  }
  div.sidebar-wrapper > nav#compactSidebar > ul.menu-categories {
    position: relative;
    display: flex;
    justify-content: center;
    align-content: flex-start;
    width: 80%;
    height: 100%;
    flex-direction: row;
    flex-wrap: wrap-reverse;
  }
  div.sidebar-wrapper > nav#compactSidebar > ul.menu-categories-right {
    display: flex;
    justify-content: end;
    align-content: start;
    width: 19%;
  }
  div.sidebar-wrapper > nav#compactSidebar > ul.menu-categories-right:before {
    content: "";
    border-left: 2px solid white;
    border-right: none;
    position: absolute;
    top: 10%;
    left: 0px;
    height: 80%;
    width: 2px;
  }
  div.sidebar-wrapper > nav#compactSidebar > ul.menu-categories > li.menu {
    position: relative;
    display: flex;
    flex: auto;
    width: 130px;
    height: 130px;
  }
  div.sidebar-wrapper
    > nav#compactSidebar
    > ul.menu-categories-right
    > li.menu {
    position: relative;
    display: flex;
    flex: auto%;
    width: 50%;
    height: 130px;
  }
  @media (max-width: 769px) {
    ul.menu-categories-right > li.menu {
      width: 120px !important;
    }
  }

  div.sidebar-wrapper
    > nav#compactSidebar
    > ul.menu-categories
    > li.menu
    > a.menu-toggle {
    width: 120px;
  }
  div.sidebar-wrapper
    > nav#compactSidebar
    > ul.menu-categories
    > li.menu
    > a.menu-toggle
    > span.badge {
    position: absolute;
    top: 12px;
    left: 9px;
    border-radius: 50px;
    height: 20px;
    width: 20px;
  }

  .fs-25 > span {
    font-size: 25px !important;
  }
  .positions {
    width: 100% !important;
    clear: both;
  }
  .apos {
    background: #a3cfc4 !important;
  }
  .aposactive {
    background: #e9b1cf !important;
  }

  .btn-deconnexion {
    background: #9bd0f9 !important;
  }
`;

const MenuTop: React.FC = () => {
  const dispatch = useAppDispatch();
  const autorisations = useAppSelector(selectedAutorisations);

  const [compactMode, setCompactMode] = useState(true);
  const [showModalParametrageMenus, setShowModalParametrageMenus] =
    useState(false);

  const Menu: AppMenuParametrageType | null = useAppSelector(ActiveMenu);

  const { t } = useTranslation();
  const navigate = useNavigate();

  const Loader = () => <div>Loading...</div>;
  const [LoadedComponent, setLoadedComponent] = useState<
    React.ComponentType<any>
  >(lazy(() => import(`../../LazyLoading/LazyDefault`)));
  const [ShowModal, setShowModal] = useState(true);
  const loadComponent = (componentName: string | null | undefined) => {
    setShowModal(true);
    if (componentName) {
      const LoadedComponent = lazy(
        () => import(`../../LazyLoading/${componentName}`)
      );
      setLoadedComponent(LoadedComponent);
    }
  };
  const loadAction = async (scriptName: string | null | undefined) => {
    if (!scriptName) return;

    let module: any;

    try {
      module = await import(`../../Shared/Hardware/${scriptName}`);
    } catch (err1) {
      try {
        module = await import(
          `../../Shared/HomologationNacef/Services/${scriptName}`
        );
      } catch (err2) {
        console.error("Failed to load script from both locations:", scriptName);
        return;
      }
    }

    try {
      if (typeof module.default === "function") {
        await module.default();
      } else if (typeof module[scriptName] === "function") {
        if(scriptName==="TiroirAction"){
        await module[scriptName](dispatch , 'open button');

        }else{
        await module[scriptName]();

        }
      } else {
        console.warn("No executable function found in module:", scriptName);
      }
    } catch (error) {
      console.error(
        "Error while executing function in module:",
        scriptName,
        error
      );
    }
  };

  const [filterText, setFilterText] = useState("");

  return (
    <MenuStyled $compactmode={compactMode} $menu={Menu}>
      <div>
        <Suspense fallback={<Loader />}>
          <LoadedComponent ShowModal={ShowModal} setShowModal={setShowModal} />
        </Suspense>
      </div>

      <div className="sidebar-wrapper sidebar-theme">
        {/* <div className="theme-logo">
          <a href="index.html">
            <img src="assets/assets/img/90x90.jpg" className="navbar-logo" alt="logo" />
            <span className="admin-logo">Clediss<span /></span>
          </a>
        </div> */}
        {/* <div className="sidebarCollapseFixed">
          <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-arrow-left"><line x1={19} y1={12} x2={5} y2={12} /><polyline points="12 19 5 12 12 5" /></svg>
        </div> */}
        <nav id="compactSidebar">
          <ul className="menu-categories">
            {!compactMode && (
              <li
                className="menu menu_items"
                style={{ width: "100%", height: "50px" }}
              >
                <input
                  style={{ height: "35px" }}
                  type="text"
                  className="form-control"
                  placeholder="Recherche ..."
                  value={filterText}
                  onChange={(e) => setFilterText(e.target.value)}
                />{" "}
              </li>
            )}
            {Menu &&
              Menu.menuItems
                .filter((item) =>
                  t(item.libelle)
                    .toLowerCase()
                    .includes(filterText.toLowerCase())
                )
                .map((item: AppMenuItemsType, index: number) => (
                  <li className="menu menu_items" key={index}>
                    {item.link ? (
                      <a
                        href={item.link ? item.link : "#"}
                        className="menu-toggle"
                        style={{
                          backgroundColor: item.bgColor,
                          border: `2px solid ${item.color}`,
                        }}
                      >
                        <div className="base-menu">
                          <div className="base-icons">
                            {item.type_icon == "icone" ? (
                              <i
                                className={item.icon}
                                style={{ color: item.color }}
                              />
                            ) : (
                              <span
                                className="fs-25"
                                style={{ color: item.color }}
                              >
                                {item.ordre + 1}
                              </span>
                            )}
                          </div>
                          <span style={{ color: item.color }}>
                            {t(item.libelle)}
                          </span>
                        </div>
                      </a>
                    ) : (
                      <a
                        href="#"
                        className="menu-toggle"
                        style={{
                          backgroundColor: item.bgColor,
                          border: `2px solid ${item.color}`,
                        }}
                        onClick={(e) => {
                          if (item.type === "Action")
                            loadAction(item.componentName);
                          else loadComponent(item.componentName);
                        }}
                      >
                        <div className="base-menu">
                          <div className="base-icons">
                            {item.type_icon == "icone" ? (
                              <i
                                className={item.icon}
                                style={{ color: item.color }}
                              />
                            ) : (
                              <span
                                className="fs-25"
                                style={{ color: item.color }}
                              >
                                {item.ordre + 1}
                              </span>
                            )}
                          </div>
                          <span style={{ color: item.color }}>
                            {t(item.libelle)}
                          </span>
                        </div>
                      </a>
                    )}
                  </li>
                ))}
          </ul>

          <ul className="menu-categories menu-categories-right">
            <li className="menu positions">
              <a
                href="#deconnection"
                data-active="false"
                className="menu-toggle btn-deconnexion"
                onClick={async (e) => {
                  await dispatch(logoutApi());
                }}
              >
                <div className="base-menu">
                  <div className="base-icons">
                    <i className="fas fa-power-off"></i>
                  </div>
                  <span>Déconnexion</span>
                </div>
              </a>
            </li>
            {autorisations && autorisations.CAN_VIEW_DASHBORD_ADMIN && (
              <li className="menu">
                <a
                  data-active="false"
                  className="menu-toggle"
                  onClick={(e) => navigate("/")}
                >
                  <div className="base-menu">
                    <div className="base-icons">
                      <i className="fas fa-chart-line"></i>
                    </div>
                    <span>{t("Dashboard")}</span>
                  </div>
                </a>
              </li>
            )}
            {Menu && !_.isUndefined(Menu._id) && (
              <>
                <li className="menu">
                  <a
                    data-active="false"
                    className="menu-toggle apos"
                    onClick={(e) => {
                      if (Menu._id) {
                        dispatch(
                          updatePositionMenusApi({
                            _id: Menu._id,
                            position: "left",
                          })
                        );
                      }
                    }}
                  >
                    <div className="base-menu">
                      <div className="base-icons">
                        <i className="fas fa-arrow-left"></i>
                      </div>
                      <span>A Gauche</span>
                    </div>
                  </a>
                </li>
                <li className="menu">
                  <a
                    data-active="false"
                    className="menu-toggle apos"
                    onClick={(e) => {
                      if (Menu._id) {
                        dispatch(
                          updatePositionMenusApi({
                            _id: Menu._id,
                            position: "right",
                          })
                        );
                      }
                    }}
                  >
                    <div className="base-menu">
                      <div className="base-icons">
                        <i className="fas fa-arrow-right"></i>
                      </div>
                      <span>A droite</span>
                    </div>
                  </a>
                </li>

                <li className="menu">
                  <a
                    data-active="false"
                    className="menu-toggle apos"
                    onClick={(e) => {
                      if (Menu._id) {
                        dispatch(
                          updatePositionMenusApi({
                            _id: Menu._id,
                            position: "down",
                          })
                        );
                      }
                    }}
                  >
                    <div className="base-menu">
                      <div className="base-icons">
                        <i className="fas fa-arrow-down"></i>
                      </div>
                      <span>En Bas</span>
                    </div>
                  </a>
                </li>

                <li className="menu">
                  <a
                    data-active="false"
                    className="menu-toggle aposactive"
                    onClick={(e) => {
                      if (Menu._id) {
                        dispatch(
                          updatePositionMenusApi({
                            _id: Menu._id,
                            position: "up",
                          })
                        );
                      }
                    }}
                  >
                    <div className="base-menu">
                      <div className="base-icons">
                        <i className="fas fa-arrow-up"></i>
                      </div>
                      <span>En Haut</span>
                    </div>
                  </a>
                </li>

                <li className="text-center positions">Position de Menu : </li>
              </>
            )}

            <li className="menu">
              {compactMode ? (
                <a
                  key={2}
                  data-active="false"
                  className="menu-toggle"
                  onClick={(e) => setCompactMode(false)}
                >
                  <div className="base-menu">
                    <div className="base-icons">
                      <i className="fas fa-chevron-down"></i>
                    </div>
                    <span>Plus</span>
                  </div>
                </a>
              ) : (
                <a
                  key={1}
                  data-active="false"
                  className="menu-toggle"
                  onClick={(e) => setCompactMode(true)}
                >
                  <div className="base-menu">
                    <div className="base-icons">
                      <i className="fas fa-chevron-up"></i>
                    </div>
                    <span>Moins</span>
                  </div>
                </a>
              )}
            </li>
            {autorisations && autorisations.CAN_VIEW_PARAM_ADMIN && (
              <li className="menu">
                <a
                  data-active="false"
                  className="menu-toggle"
                  onClick={(e) => setShowModalParametrageMenus(true)}
                >
                  <div className="base-menu">
                    <div className="base-icons">
                      <i className="fas fa-cogs"></i>
                    </div>
                    <span>Paramétres</span>
                  </div>
                </a>
              </li>
            )}
          </ul>
        </nav>
      </div>

      {/* Parametrage Menus Form */}
      <ParametrageModal
        showModal={showModalParametrageMenus}
        setShowModal={setShowModalParametrageMenus}
      />
    </MenuStyled>
  );
};

export default MenuTop;
